$(document).ready(function() {
    $(".stock-slider").slick({
        arrows: false,
        dots: true,
        infinite: false,
        slidesToShow: 1,
    })
})